/**
 * Shared officer live-status logic.
 * An officer is considered "live" ONLY if:
 *   1. Their `last_seen` timestamp is within the staleness threshold (default 5 min)
 * The `status` column in the DB is a hint but is NOT reliable on its own
 * because mobile browsers can kill tabs without firing cleanup events.
 */

const STALE_THRESHOLD_MS = 5 * 60 * 1000; // 5 minutes

export function isOfficerLive(officer: { status: string; last_seen: string | null }): boolean {
  if (!officer.last_seen) return false;
  const elapsed = Date.now() - new Date(officer.last_seen).getTime();
  return elapsed < STALE_THRESHOLD_MS;
}

export function lastSeenAgo(lastSeen: string | null): string {
  if (!lastSeen) return "—";
  const mins = Math.floor((Date.now() - new Date(lastSeen).getTime()) / 60000);
  if (mins < 1) return "Just now";
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  return `${Math.floor(hrs / 24)}d ago`;
}
